<div fxLayout="column" fxLayoutGap="15px">
    <h3>Submissions</h3>
    <!-- <p>{{ data }}</p> -->
    <div fxLayout="row" fxLayoutGap="10px" *ngFor="let ev of data">
        <!-- {{ ev }} -->
        <div>{{ev.key}}</div>
        <a [href]="ev.value" target="_blank">{{ev.value}}</a>
    </div>
</div>